import React from 'react';
import { MDBDataTable } from 'mdbreact';
import { Button } from 'reactstrap';

const columns = [
 
  {
    label: 'Email',
    field: 'email',
    sort: 'asc',
    width: 200,
  },

  {
    label: 'FirstName',
    field: 'fname',
    sort: 'asc',
    width: 300,
  },
  {
    label: 'LastName',
    field: 'lname',
    sort: 'asc',
    width: 300,
  },
  

  {
    label: 'Actions',
    field: 'actions',
    sort: 'disabled',
    width: 100,
  },
];
const CcrList = (props) => {
  return (
    <>
      <MDBDataTable
        btn
        responsive
        bordered
        data={{
          columns: columns,
          rows:
            props.ccrs &&
            props.ccrs.map((x) => ({
              
              email: x.email,
              fname: x.firstName,
              lname: x.lastName,
              actions: (
                <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                <Button color='info' onClick={() => props.editCcr(x)}>
                  Edit
                </Button>

                <Button color='primary' size='sm' onClick={()=> props.onStatusChange(x, !x.isActive)} >
                  {x.isActive ? 'Deactivate' : 'Activate' }
                </Button>
                </div>
                
              ),
              
            })),
        }}
      />
    </>
  );
};

export default CcrList;
